import { useCallback, useRef } from 'react';
import { IHandleSetInputParams } from '../types';
import { THandleDelInput } from './types';
import { isArray, isFunction, isRegExp, omit, reduce } from 'lodash';

export const useHandleDelInput = ({
  inputs,
  setInputs,
}: IHandleSetInputParams): THandleDelInput => {
  const inputsRef = useRef(inputs);
  inputsRef.current = inputs;

  return useCallback(
    (criteria: string | string[] | RegExp | Function) => {
      const current = inputsRef.current;
      let newInputs = {};
      if (isRegExp(criteria)) {
        newInputs = reduce(
          current,
          (r, v, k) => {
            if (criteria.test(k)) return { ...r };
            return { ...r, [k]: v };
          },
          {}
        );
      } else if (isFunction(criteria)) {
        newInputs = reduce(
          current,
          (r, v, k) => {
            if (criteria(v)) return { ...r };
            return { ...r, [k]: v };
          },
          {}
        );
      } else if (isArray(criteria)) {
        newInputs = omit(current, criteria);
      } else {
        newInputs = omit(current, criteria as string);
      }
      setInputs(newInputs);
    },
    [setInputs]
  );
};
